module.exports = __webpack_public_path__ + "static/media/coding-lesson-tutorial-for-kid.f627a7ef.webp";